<template>
  <a-checkbox :checked="checked" @change="handleChange" :disabled="disabled">
    <slot></slot>
  </a-checkbox>
</template>
<script>
  export default {
    props: ['value', 'disabled'],
    data () {
      return {
        checked: this.value
      }
    },
    methods: {
      handleChange (e) {
        this.$emit('input', e.target.checked)
        this.$emit('change', e.target.checked)
      }
    },
    watch: {
      value () {
        this.checked = this.value
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/components/ui/v2/checkbox.vue